import { useCallback } from 'react';

import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import { Api } from 'src/models/Api.model';
import {
  convertPracticeSettings,
  convertUserSettings,
} from 'src/models/GalenData/helpers/saveSettings';
import { AxiosResponseWithRefreshToken } from 'src/models/GalenData/Request.model';
import { GalenDataUser } from 'src/models/GalenData/User.model';

const useSetCurrentUserInfo = () => {
  const { setAuth, setCurrentUser, setUserSettings, setPracticeSettings } =
    useRemoteBoundStore();

  const setCurrentUserInfo = useCallback(
    async (res: AxiosResponseWithRefreshToken<GalenDataUser>) => {
      const authToken = res.headers.authorization;
      const refreshToken = res.headers['x-refresh-token'];

      setAuth({
        authInfo: { authToken, refreshToken },
      });

      const data = res.data;
      const practiceId = data.currentRole?.practice?.practiceId;

      if (practiceId) {
        const [userSettings, practiceSettings] = await Promise.all([
          Api.remote.getUserSettings(data.userId),
          Api.remote.getPracticeSettings(practiceId),
        ]);

        const userSettingsData = convertUserSettings(userSettings.data);
        const practiceSettingsData = convertPracticeSettings(
          practiceSettings.data,
        );

        setUserSettings({ userSettings: userSettingsData });
        setPracticeSettings({ practiceSettings: practiceSettingsData });
        setCurrentUser({ currentUser: data });
      }
    },
    [setAuth, setUserSettings, setPracticeSettings, setCurrentUser],
  );

  return { setCurrentUserInfo };
};

export default useSetCurrentUserInfo;
